import { Badge } from '@ps/isp-web-component-library';
import { PriceBoost } from '@ps/isp-web-component-library/icons/PriceBoost';
import type { CompetitionId } from '@ps/isp-web-services-types';
import React from 'react';
import { useSelector } from 'react-redux';

import { useRegulatoryIntl } from '@swf/core/hooks/useRegulatoryIntl';
import type { RootState } from '@swf/core/store';
import { DefaultLink } from '@swf/sports/components';

import { useSportsCompetitionsWidget } from '../../model';

import { TXTWCL_N0_logo, TXTWCL_odds_boost_selections } from './Competition.messages.json';
import styles from './Competition.scss';

export interface Props {
  competitionId: CompetitionId;
}

const Competition: React.FC<Props> = ({ competitionId }) => {
  const { widgetSelect } = useSportsCompetitionsWidget();

  const competition = useSelector((state: RootState) =>
    widgetSelect.competition(state, competitionId)
  );
  const eventType = useSelector((state: RootState) =>
    widgetSelect.eventType(state, competition.eventTypeId)
  );

  const { formatMessage } = useRegulatoryIntl();

  const { eventTypeId, eventTypeSlug } = eventType;
  const { competitionSlug, oddsBoostCount, competitionName, logoUrl } = competition;

  return (
    <DefaultLink
      key={competitionId}
      alias="sportsCompetition"
      values={{ eventTypeSlug, eventTypeId, competitionSlug, competitionId }}
    >
      {competitionName}
      {logoUrl ? (
        <img
          className={styles.competitionLogo}
          src={logoUrl}
          alt={formatMessage(TXTWCL_N0_logo, { competitionName })}
        />
      ) : null}

      {oddsBoostCount ? (
        <Badge
          count={oddsBoostCount}
          icon={PriceBoost}
          iconLabel={formatMessage(TXTWCL_odds_boost_selections)}
          className={styles.badge}
          size="sm"
        />
      ) : null}
    </DefaultLink>
  );
};

export default Competition;
